import { useState } from "react";

import type { IButton } from "@Components/Button";
import { Button } from "@Components/Button";
import { Loading } from "@Components/Loading";
import type { IModal } from "@Components/Modal";
import { Modal } from "@Components/Modal";
import type { IAjax } from "@Components/Modules/Ajax";
import { Ajax, AjaxMethod } from "@Components/Modules/Ajax";

import * as css from "./ResetPasswordForm.module.css";

export interface IResetPasswordForm extends IModal, IAjax {
    title: string;
    email: string;
    descriptionAboveEmail: string;
    descriptionBelowEmail: string;
    button?: IButton;
}

export const ResetPasswordForm = (props: IResetPasswordForm) => {
    const [state, setState] = useState({ isOpen: true, isLoading: false, disableButton: false });

    const [ajax] = useState(new Ajax({ ...props, ajaxMethod: AjaxMethod.Post }));

    ajax.fail = () => {
        setState({ isLoading: false, disableButton: false, isOpen: state.isOpen });
        return true;
    };

    ajax.success = () => {
        setState({ isOpen: false, isLoading: false, disableButton: false });
        if (props.onClose) {
            props.onClose();
        }
    };

    const onClickResetPassword = (ev: React.MouseEvent<HTMLAnchorElement>): void => {
        ev.preventDefault();
        setState({ isLoading: true, disableButton: true, isOpen: state.isOpen });
        ajax.request();
    };

    return (
        <Modal
            {...props}
            closeOnEsc={false}
            closeOnBlur={false}
            isOpen={state.isOpen}
            onClose={props.onClose}
            className={css.resetPasswordFormComponent}
        >
            <h4 className={css.header}>{props.title}</h4>
            {props.descriptionAboveEmail && (
                <div className={css.descriptionAboveEmail}>{props.descriptionAboveEmail}</div>
            )}
            {props.email && <div className={css.email}>{props.email}</div>}
            {props.descriptionBelowEmail && (
                <div className={css.descriptionBelowEmail}>{props.descriptionBelowEmail}</div>
            )}
            {state.isLoading && <Loading isModal={true} />}
            {props.button && (
                <Button {...props.button} onClick={onClickResetPassword} disabled={state.disableButton} />
            )}
        </Modal>
    );
};
